import Roles from "../models/Roles";
import axios from "axios";

let http = axios.create({
  baseURL: `${process.env.VUE_APP_API_ROOT_URL}/api/v1`,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`
  }
});

export default /**
 * Class for control the authentication in app
 */
class AuthController {
  constructor(resource, router, message = null) {
    if (resource) {
      this._resource = resource;
    }
    if (router) {
      this._router = router;
    }
    if (message) {
      this._message = message;
    }
  }

  /**
   * Login in app
   *
   * @param {String} user
   * @param {String} password
   */
  async login(email, password, client_id) {
    return await http
      .post("/token", {
        email: email,
        password: password,
        client_id: client_id,
        app: 'carsharing',
      })
      .then(
        async res => {
          if (res.status == 201) {
            let auth = res.data;
            if (auth.profile != Roles.User) {
              this._message.error(
                "O acesso ao painel administrativo deve ser realizado via navegador"
              );
              return;
            }
            localStorage.setItem("pickn_user", auth.user_id);
            localStorage.setItem("access_token", auth.access_token);
            localStorage.setItem("profile", auth.profile);
            localStorage.setItem("client_id", auth.client_id);
            localStorage.setItem("verify_number", 0);
            localStorage.setItem("type_client", auth.type_client);

            // await setThemeColors(auth)

            localStorage.removeItem("colors");
            localStorage.removeItem("images");

            if (auth.hasforpasswordchange) {
              return this._router.push({
                name: "newPasswordUser",
                params: { email: auth.email }
              });
            }

            let requests = await http.get(
              `/vehicleRequest/client/${localStorage.getItem("client_id")}`,
              { headers: { Authorization: `Bearer ${auth.access_token}` } }
            );

            let requestInCheckStage = requests.data.filter(request => {
              if (
                (request.step.code === "check-in" ||
                  request.step.code === "check-out") &&
                request.user_id === auth.user_id &&
                request.cancelled_by === null
              ) {
                return request;
              }
            });
            if (requestInCheckStage.length >= 1) {
              return this._router.push({
                name: "driver-vehicle-request-dashboard"
              });
            }
            return this._router.push({ name: "driver-vehicle-request" });
          } else {
            return res.data.map(i => {
              return {
                id: i.clientid,
                name: i.client_name
              };
            });
          }
        },
        err => {
         
          if(err.response.data.NotApproved){
            this._router.push({ name: "registerstatus" });
          }
          else{
            this._message.error(err.response.data.message);
          }
        }
      );
  }

  logout() {
    try {
      this._resource("invalidate-token").save({
        token: localStorage.getItem("access_token")
      });
    } catch (error) {
      console.log(error)
    }
    
    localStorage.removeItem("access_token");
    localStorage.removeItem("client_id");
    localStorage.removeItem("profile");
    localStorage.removeItem("pageBack");
    localStorage.removeItem("rememberMe");
    localStorage.removeItem("verify_number");
    this._router.push({ name: "login" });
  }

  accessResetPassword(email, token) {
    return this._resource("token/reset-password")
      .save({ email, token })
      .then(res => res.json())
      .then(
        auth => {
          localStorage.setItem("access_token", auth.access_token);
        },
        err => {
          console.log(err);
          if (err.status == 401) {
            this._router.push({ name: "login" });
          }
        }
      );
  }

  accessToChangeEmail(currentEmail, newEmail, token) {
    return this._resource("token/change-email")
      .save({ currentEmail, newEmail, token })
      .then(res => res.json())
      .then(
        auth => {
          localStorage.setItem("access_token", auth.access_token);
        },
        err => {
          console.log(err);
          if (err.status == 401) {
            this._router.push({ name: "login" });
          }
        }
      );
  }

  changePassword(password) {
    return this._resource("change-password")
      .save({ password })
      .then(
        res => {
          this._message({
            type: "success",
            message: "Senha alterada com sucesso!"
          });
        },
        err => {
          this._message.error("Houve um erro ao alterar a senha");
        }
      );
  }

  forgotPassword(email) {
    return this._resource("forgot-password").save({ email });
  }

  changeEmail(newEmail) {
    return this._resource("user/change-email")
      .save({ newEmail })
      .then(
        res => {
          this._message({
            type: "success",
            message: "E-mail alterado com sucesso!"
          });
        },
        err => {
          this._message.error("Houve um erro ao alterar o e-mail");
        }
      );
  }

  reloadToken(client_id) {
    return this._resource("token/client")
      .save({ client_id: client_id })
      .then(res => {
        let auth = res.body;
        localStorage.setItem("pickn_user", auth.user_id);
        localStorage.setItem("access_token", auth.access_token);
        localStorage.setItem("profile", auth.perfil);
        localStorage.setItem("client_id", client_id);
        localStorage.setItem("verify_number", 0);
      });
  }
}
